import {
  SectionElement,
  defineElement,
  on,
  onClick,
  query,
  queryAll,
  wait
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/shop-contact-form/shop-contact-form.ts
var ShopContactForm = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.steps = ["first-step", "second-step", "third-step", "fourth-step", "fifth-step", "success"];
    this.step = 1;
    this.recaptchaLoaded = false;
  }
  connectedCallback() {
    this.updateStepTabIndices();
  }
  onConsentCheckboxChange() {
    if (this.consentCheckbox.checked && !this.recaptchaLoaded) {
      this.loadRecaptchaScript();
    }
  }
  loadRecaptchaScript() {
    return __async(this, null, function* () {
      if (this.recaptchaLoaded)
        return;
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/api.js?render=6LeEl08qAAAAABhP6ACT65yJS2CZ-WJLm1YB55fM";
        script.async = true;
        script.defer = true;
        script.onload = () => {
          this.recaptchaLoaded = true;
          resolve();
        };
        script.onerror = () => reject(new Error("Failed to load reCAPTCHA script"));
        document.head.appendChild(script);
      });
    });
  }
  handleKeydown(input, event) {
    if (event.key === "Enter") {
      event.preventDefault();
      input.click();
    }
  }
  updateStepTabIndices() {
    const currentStepClass = this.steps[this.step - 1];
    this.allSteps.forEach((step) => {
      const stepDataAttr = step.getAttribute("data-first-step") !== null ? "first-step" : step.getAttribute("data-second-step") !== null ? "second-step" : step.getAttribute("data-third-step") !== null ? "third-step" : step.getAttribute("data-fourth-step") !== null ? "fourth-step" : step.getAttribute("data-fifth-step") !== null ? "fifth-step" : step.getAttribute("data-success") !== null ? "success" : "";
      const isActiveStep = stepDataAttr === currentStepClass;
      const focusableElements = step.querySelectorAll('input, button, textarea, select, [tabindex]:not([tabindex="-1"])');
      focusableElements.forEach((element) => {
        if (isActiveStep) {
          element.removeAttribute("tabindex");
        } else {
          element.setAttribute("tabindex", "-1");
        }
      });
    });
  }
  onContinueClick(elm) {
    return __async(this, null, function* () {
      let valid = true;
      if (this.step === 2) {
        this.inputsSecond.forEach((input) => {
          if (!input.validity.valid) {
            valid = false;
            this.classList.add("error");
          }
        });
      } else if (this.step === 3) {
        this.inputsThird.forEach((input) => {
          if (!input.validity.valid) {
            valid = false;
            this.classList.add("error");
          }
        });
      } else if (this.step === 5) {
        this.inputsFifth.forEach((input) => {
          if (!input.validity.valid) {
            valid = false;
            this.classList.add("error");
          }
        });
        if (valid) {
          yield this.submitForm(elm);
          return;
        }
      }
      if (!valid)
        return;
      yield this.changeStep(1, elm);
    });
  }
  changeStep(delta, loadingIndicator) {
    return __async(this, null, function* () {
      const prevStep = this.step;
      const nextStep = Math.max(prevStep + delta, 1);
      this.step = nextStep;
      const prevClass = this.steps[prevStep - 1];
      const nextClass = this.steps[nextStep - 1];
      loadingIndicator == null ? void 0 : loadingIndicator.setAttribute("loading", "");
      loadingIndicator == null ? void 0 : loadingIndicator.removeAttribute("loading");
      this.classList.remove("error");
      this.classList.remove(prevClass);
      this.classList.add(nextClass);
      this.updateStepTabIndices();
      yield wait(300);
    });
  }
  onBackClick() {
    return __async(this, null, function* () {
      yield this.changeStep(-1);
    });
  }
  onResetClick() {
    return __async(this, null, function* () {
      this.step = 1;
      this.classList.remove("success", "error");
      this.classList.add("first-step");
      this.updateStepTabIndices();
      this.querySelectorAll("input, textarea").forEach((element) => {
        if (element instanceof HTMLInputElement) {
          if (element.type === "checkbox") {
            element.checked = false;
          } else {
            element.value = "";
          }
        } else if (element instanceof HTMLTextAreaElement) {
          element.value = "";
        }
      });
    });
  }
  submitForm(loadingIndicator) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      try {
        if (!this.consentCheckbox.checked) {
          throw new Error("User has not given consent for reCAPTCHA.");
        }
        loadingIndicator.setAttribute("loading", "");
        if (!this.recaptchaLoaded) {
          yield this.loadRecaptchaScript();
        }
        const captchaToken = yield this.executeRecaptcha();
        const supportTypeCheckboxes = this.querySelectorAll('input[name="contact[reason]"]:checked');
        const supportType = Array.from(supportTypeCheckboxes).map((cb) => cb.value);
        const productName = ((_a = this.querySelector('input[name="contact[product]"]')) == null ? void 0 : _a.value) || "";
        const productId = ((_b = this.querySelector('input[name="contact[productid]"]')) == null ? void 0 : _b.value) || "";
        const originalMessage = ((_c = this.querySelector('textarea[name="contact[body]"]')) == null ? void 0 : _c.value) || "";
        let message = originalMessage;
        if (productName)
          message += ` - ${productName}`;
        if (productId)
          message += ` - ${productId}`;
        const formData = {
          lang: this.dataset.lang || "en",
          captchaToken,
          supportType,
          name: ((_d = this.querySelector('input[name="contact[first_name]"]')) == null ? void 0 : _d.value) || "",
          lastName: ((_e = this.querySelector('input[name="contact[last_name]"]')) == null ? void 0 : _e.value) || "",
          company: ((_f = this.querySelector('input[name="contact[company]"]')) == null ? void 0 : _f.value) || "",
          email: ((_g = this.querySelector('input[name="contact[email]"]')) == null ? void 0 : _g.value) || "",
          phone: ((_h = this.querySelector('input[name="contact[phone]"]')) == null ? void 0 : _h.value) || "",
          message
        };
        const response = yield fetch("/apps/bb-tools/submitContact", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData)
        });
        const result = yield response.json();
        if (!result.success) {
          this.classList.add("error");
          console.error("shop-contact-form error:", result.error);
          return;
        }
        yield this.changeStep(1, loadingIndicator);
      } catch (error) {
        this.classList.add("error");
        console.error("shop-contact-form error:", error);
      } finally {
        loadingIndicator.removeAttribute("loading");
      }
    });
  }
  executeRecaptcha() {
    return __async(this, null, function* () {
      if (!window.grecaptcha) {
        throw new Error("reCAPTCHA not loaded.");
      }
      return yield new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute("6LeEl08qAAAAABhP6ACT65yJS2CZ-WJLm1YB55fM", { action: "submit" }).then(resolve).catch(reject);
        });
      });
    });
  }
};
__decorateClass([
  queryAll("[data-input-second]")
], ShopContactForm.prototype, "inputsSecond", 2);
__decorateClass([
  queryAll("[data-input-third]")
], ShopContactForm.prototype, "inputsThird", 2);
__decorateClass([
  queryAll("[data-input-fifth]")
], ShopContactForm.prototype, "inputsFifth", 2);
__decorateClass([
  queryAll("[data-first-step], [data-second-step], [data-third-step], [data-fourth-step], [data-fifth-step], [data-success]")
], ShopContactForm.prototype, "allSteps", 2);
__decorateClass([
  query("[data-consent-checkbox]")
], ShopContactForm.prototype, "consentCheckbox", 2);
__decorateClass([
  on("change", "[data-consent-checkbox]")
], ShopContactForm.prototype, "onConsentCheckboxChange", 1);
__decorateClass([
  on("keydown", "input")
], ShopContactForm.prototype, "handleKeydown", 1);
__decorateClass([
  onClick("[data-continue]")
], ShopContactForm.prototype, "onContinueClick", 1);
__decorateClass([
  onClick("[data-back]")
], ShopContactForm.prototype, "onBackClick", 1);
__decorateClass([
  onClick("[data-reset]")
], ShopContactForm.prototype, "onResetClick", 1);
ShopContactForm = __decorateClass([
  defineElement("shop-contact-form")
], ShopContactForm);
export {
  ShopContactForm
};
